import React from 'react';
import { Button, CircularProgress, Box } from '@mui/material';

const LoadingButtonWrapper = ({
  loading = false,
  disabled = false,
  title = 'Submit',
  type = 'button',
  loadingText = 'Processing...',
  onClick,
  style,
  size,
  fontFamily,
  height,
  fontSize,
  startIcon, // 👈 new prop add kiya
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <Button
      disabled={isDisabled}
      fullWidth
      onClick={onClick}
      size={size ? size : 'large'}
      variant="contained"
      type={type}
      style={style}
      startIcon={!loading && startIcon ? startIcon : null} // 👈 icon only when not loading
      sx={{
        height: height ? height : 40,
        fontFamily: fontFamily ? fontFamily : 'poppinsSemiBold',
        fontSize: fontSize ? fontSize : 14,
        ...(disabled && !loading
          ? {
              backgroundColor: '#e0e0e0',
              color: '#9e9e9e',
              '&:hover': {
                backgroundColor: '#e0e0e0'
              }
            }
          : {
              '&.Mui-disabled': {
                backgroundColor: (theme) => theme.palette.primary.main,
                color: '#fff',
                opacity: 0.8
              }
            })
      }}
      {...props}
    >
      {loading ? (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={16} color="inherit" />
          {loadingText}
        </Box>
      ) : (
        title
      )}
    </Button>
  );
};

export default LoadingButtonWrapper;
